import React, { useEffect, useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { OtpModal } from '../components/auth/OtpModal';
export function Login() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState<'email' | 'sent'>('email');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resendCooldown, setResendCooldown] = useState(0);
  const [showOtp, setShowOtp] = useState(false);
  const {
    sendMagicLink,
    verifyMagic,
    isAuthenticated,
    needsProfileSetup
  } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => setResendCooldown(c => c - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);
  if (isAuthenticated && !needsProfileSetup) {
    return <Navigate to="/" replace data-id="element-739" />;
  }
  const handleSendLink = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError('');
    try {
      await sendMagicLink(email);
      setState('sent');
      setResendCooldown(60);
    } catch (err) {
      setError('Error al enviar el enlace');
    } finally {
      setLoading(false);
    }
  };
  const handleResend = async () => {
    if (resendCooldown > 0) return;
    setLoading(true);
    try {
      await sendMagicLink(email);
      setResendCooldown(60);
    } catch (err) {
      setError('Error al reenviar');
    } finally {
      setLoading(false);
    }
  };
  const handleSimulateVerify = async () => {
    setLoading(true);
    try {
      await verifyMagic('simulated-token-123');
    } catch (err) {
      setError('Error al verificar');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center p-4" data-id="element-740">
      <div className="w-full max-w-[560px] bg-white/[0.02] rounded-[12px] p-8 border border-white/5" data-id="element-741">
        {state === 'email' ? <>
            <h1 className="text-[26px] font-bold text-white leading-[34px] mb-2 text-center" data-id="element-742">
              Acceso a Growthly
            </h1>
            <p className="text-[14px] text-[#9E9E9E] mb-8 text-center" data-id="element-743">
              Introduce tu correo para recibir un enlace de acceso seguro.
            </p>

            <form onSubmit={handleSendLink} className="space-y-6" data-id="element-744">
              <div data-id="element-745">
                <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="correo@empresa.com" className="w-full h-12 px-4 bg-[#141414] border border-white/5 rounded-lg text-white placeholder-[#7f7f7f] focus:border-[#27AE60] focus:outline-none transition-colors" data-id="element-746" />
              </div>

              {error && <p className="text-[#D64545] text-sm text-center" data-id="element-747">{error}</p>}

              <button type="submit" disabled={loading || !email} className="w-full h-11 bg-[#27AE60] text-[#0B0B0B] font-medium rounded-lg hover:-translate-y-[1px] transition-transform duration-180 disabled:opacity-50 disabled:hover:translate-y-0 flex items-center justify-center" data-id="element-748">
                {loading ? <div className="w-5 h-5 border-2 border-[#0B0B0B]/20 border-t-[#0B0B0B] rounded-full animate-spin" data-id="element-749" /> : 'Enviar enlace de acceso'}
              </button>

              <div className="text-center pt-2" data-id="element-750">
                <button type="button" onClick={() => setShowOtp(true)} className="text-[12px] text-[#9E9E9E] hover:text-white transition-colors" data-id="element-751">
                  Usar código por SMS/OTP
                </button>
              </div>
            </form>
          </> : <div className="text-center" data-id="element-752">
            <div className="w-16 h-16 bg-[#27AE60]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-753">
              <svg className="w-8 h-8 text-[#27AE60]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-754">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-755" />
              </svg>
            </div>

            <h2 className="text-[22px] font-semibold text-white mb-4" data-id="element-756">
              Revisa tu correo
            </h2>
            <p className="text-[14px] text-[#E6E6E6] mb-8" data-id="element-757">
              Hemos enviado un correo a{' '}
              <span className="font-medium text-white" data-id="element-758">{email}</span>. Revisa tu
              bandeja (y spam). El enlace expira en 15 minutos.
            </p>

            <div className="space-y-4" data-id="element-759">
              <button onClick={handleResend} disabled={resendCooldown > 0 || loading} className="w-full h-11 border border-white/10 text-[#E6E6E6] font-medium rounded-lg hover:bg-white/5 transition-colors disabled:opacity-50" data-id="element-760">
                {resendCooldown > 0 ? `Reenviar enlace (${resendCooldown}s)` : 'Reenviar enlace'}
              </button>

              <button onClick={() => setShowOtp(true)} className="text-[14px] text-[#9E9E9E] hover:text-white transition-colors" data-id="element-761">
                Ingresar código manualmente
              </button>
            </div>

            <div className="mt-8 p-4 bg-[#141414] border border-white/5 rounded-lg" data-id="element-762">
              <p className="text-[12px] text-[#9E9E9E] mb-3" data-id="element-763">
                Demo: usa el botón Verificar Ahora para simular click del enlace
              </p>
              <button onClick={handleSimulateVerify} disabled={loading} className="w-full h-9 bg-white/10 text-white text-[13px] font-medium rounded hover:bg-white/20 transition-colors flex items-center justify-center" data-id="element-764">
                {loading ? <div className="w-4 h-4 border-2 border-white/20 border-t-white rounded-full animate-spin" data-id="element-765" /> : 'Verificar Ahora'}
              </button>
            </div>
          </div>}
      </div>

      {showOtp && <OtpModal email={email || 'demo@growthly.com'} onClose={() => setShowOtp(false)} onSuccess={() => setShowOtp(false)} data-id="element-766" />}
    </div>;
}